export default __webpack_public_path__ + "static/media/mouse-rotate.0cd3a5dc.svg";